<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                </div>
            </div>
            <div class="admin_table_main">
                <el-table :data="info" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                    <el-table-column prop="F_IN_ID" label="#"  width="70px"></el-table-column>
                    <el-table-column prop="F_VR_KECMC" label="课程名称"></el-table-column>
                    <el-table-column prop="F_VR_ZL" label="课程资料"></el-table-column>

                    <el-table-column label="操作" fixed="right" width="120px">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-edit" @click="$router.push({name:'keczl_form',params:{id:scope.row.F_IN_ID}})">编辑</el-button>
                            <!-- <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button> -->
                        </template>
                    </el-table-column>

                </el-table>
                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { videoPlayer } from 'vue-video-player';
    import 'video.js/dist/video-js.css'
    export default {
        components: {videoPlayer},
        computed:{
            player(){
                return this.$refs.videoPlayer.player
            }
        },
        props: {},
        data() {
            return {
                list:[],
                total_data:0, // 总条数
                page_size:20,
                current_page:1,
                select_id:'',
                adv_position_id:0,
                where:{
                },
                info:[],
                playerOptions:{
                    //播放速度
                    playbackRates:[0.5,1.0,1.5,2.0],
                    //如果true,浏览器准备好时开始回放.
                    autoplay:false,
                    //默认情况下将会消除任何音频
                    muted:false,
                    //导致视频一结束就重新开始
                    loop:false,
                    //建议浏览器在<video>加载元素后是否应该开始下载视频
                    preload:'auto',
                    language:'zh-CN',
                    aspectRatio:'16:9',
                    fluid:true,
                    sources:[{
                        //类型
                        type:"video/mp4",
                        //url地址
                        // src:'http://wechat.cloudliveshop.com/Uploads/upload/1610248596.mp4'
                    }],
                    poster:'',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息
                    notSupportedMessage:'此视频暂无法播放，请稍后再试',
                    controlBar:{
                        timeDivider:true,
                        durationDisplay:true,
                        remainingTimeDisplay:false,
                        //全屏按钮
                        fullscreenToggler:true
                    }
                }
            };
        },
        watch: {},
        methods: {
            handleSelectionChange:function(e){
                let ids = [];
                e.forEach(v => {
                    ids.push(v.F_IN_ID);
                });
                this.select_id = ids.join(',');
            },
            get_adv_list:function(){
                this.where.page = this.current_page;
                this.$get(this.$api.getKeczl,this.where).then(res=>{
                    this.page_size = res.data.per_page;
                    this.total_data = res.data.total;
                    this.current_page = res.data.current_page;
                    this.info = res.data.data;
                })
            },
            // 删除处理
            del:function(F_IN_ID){
                if(this.$isEmpty(F_IN_ID)){
                    return this.$message.error('请先选择删除的对象');
                }
                this.$post(this.$api.delZhaopzbsp,{F_IN_ID:F_IN_ID}).then(res=>{
                    if(res.code == 200){
                        this.get_adv_list();
                        return this.$message.success("删除成功");
                    }else{
                        return this.$message.error("删除失败");
                    }
                });
            },
            current_change:function(e){
                this.current_page = e;
                this.get_adv_list();
            },
        },
        created() {
            this.get_adv_list();
        },
        mounted() {}
    };
</script>
<style lang="scss" scoped>
</style>